import React from 'react';
import './index.scss';

export default function logoText(argument) {
  return (
    <div className="logo-text">
      <h3>GIZMO</h3>
      <p>及目科技出品</p>
    </div>
  )
}